import React from "react";
import { motion } from "framer-motion";

function Features() {
  const features = [
    {
      title: "Text Preprocessing",
      description:
        "We clean, normalize, and prepare textual data by removing noise, handling stop words, stemming, lemmatization, and tokenization for accurate NLP workflows.",
      color: "#7AC943",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Sentiment Analysis",
      description:
        "Our NLP solutions help analyze emotions and opinions in customer feedback, social media posts, and reviews to uncover actionable insights.",
      color: "#3FA34D",
      animation: { x: 100, y: 0 }, // from right
    },
    {
      title: "Named Entity Recognition (NER)",
      description:
        "We build models that identify entities like people, organizations, dates, and locations from unstructured text, enabling smarter data extraction.",
      color: "#00A7C4",
      animation: { x: 0, y: 100 }, // from bottom
    },
    {
      title: "Chatbots & Virtual Assistants",
      description:
        "We design and deploy intelligent conversational agents powered by NLP, enabling human-like interactions for customer support and business automation.",
      color: "#0077B6",
      animation: { x: 0, y: -100 }, // from top
    },
    {
      title: "Text Summarization",
      description:
        "Our NLP pipelines can automatically summarize long documents, news articles, or reports, making large volumes of text easier to digest and analyze.",
      color: "#FF9800",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Language Translation",
      description:
        "We build multilingual NLP models that translate text across different languages while preserving context, meaning, and cultural nuances.",
      color: "#9C27B0",
      animation: { x: 100, y: 0 }, // from right
    },
  ];

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "28px",
      marginBottom: "30px",
      fontWeight: "bold",
      letterSpacing: "0px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      padding: "20px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "200px",
      cursor: "pointer",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#4b5563",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Unlock the Power of Natural Language Processing</h2>
      <div style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={feature.animation}
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
